import React,{useEffect} from 'react'
import Widget from '../../Widget'
import {    Form,  Radio, Row, Col,Button } from 'antd'
import PricingTable from 'components/PricingTable'
import IntlMessages from "util/IntlMessages"
import blueTick from 'assets/images/tick-blue@2x.png'
import greenTick from 'assets/images/tick-green@2x.png'
import { useDispatch,useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { DataRequestAction,DataGetAction } from 'redux/actions/http'
import SimpleModal from 'components/Modal/SimpleModal'

const Index = () => {



   

    const history = useHistory();
    const [form] = Form.useForm();

    const params = useLocation();
    const {query} = params
    const dispatch = useDispatch()
    console.log('============query=============',query)
    const signupProps = useSelector(state => state.signUp)
    const {subscriptionPlan,memeberShipPlanSuccess,memberShipPlan,freemessageModelVisible,currentPlan} = signupProps



    console.log('================currentPlan=========',currentPlan)
    const fetchplanSettings = () => {
        dispatch(DataGetAction('getPlanSetting', '', 'gettingPlanSettings'));
       


    }

    useEffect(fetchplanSettings, [params]);

    const freeList = [
        <IntlMessages id="pricingTable.free.oneUserAccess" />,
        <IntlMessages id="pricingTable.free.nusringReportOn1Healthconfition" />,
        <IntlMessages id="pricingTable.free.nusringReportOn3CareNeeds" />,
        <IntlMessages id="pricingTable.free.abilityToControl1Report" />,
        <IntlMessages id="pricingTable.free.trialPeriod" />,

    ]

    const premiumList = [
        // <IntlMessages id="pricingTable.premium.multipleUsers" />,
        <IntlMessages id="pricingTable.premium.unlimitedNursingReport" />,
        <IntlMessages id="pricingTable.premium.nusringReportOnallCareNeeds" />,
        <IntlMessages id="pricingTable.premium.abilityToControlUnlimitedReport" />,
        <IntlMessages id="pricingTable.premium.identifyRedFlags" />,
        <IntlMessages id="pricingTable.premium.recieveEmail" />,


    ]

    const onChange = (e) => {
        // dispatch({
        //     type: 'SET_SUBSCRIPTION_PLAN',
        //     payload: e.target.value
        // })
        if(e.target.value === 'free'){
            dispatch(DataRequestAction('PUT', 'updatePlanInfo', {'memberShipPlan' :  e.target.value}, '', 'savingUserDetail', false));
        }
        else{
            history.push({
                pathname :'/planCheckout',
            })
        }
        
        
    }
    if(memeberShipPlanSuccess &&  memberShipPlan === 'free'){
        dispatch({
            type : 'freeMessageSuccess_modal',
            
        })
        dispatch({
            type : 'reset_states'
        })
    }
    else if(memeberShipPlanSuccess &&  memberShipPlan === 'premium'){
        dispatch({
            type : 'reset_states'
        })
        history.push({
            pathname :'/planCheckout',
        })
    }
    // const toggleModalAndStartQuestionnaire = ()=>{
        
    //     dispatch({
    //         type : 'messageSuccess_modal',
            
    //     })
    //     dispatch({
    //         type : 'questionnaire_modal',
            
    //     })
    // }

    const redirectToQuestions = () =>{
        dispatch({
            type : 'freeMessageSuccess_modal'
        })
        dispatch({
            type : 'questionnaire_modal'
        })
        history.push('/questionsModal')
    }
    return (
        <Widget styleName="gx-paddingAuth">
            <div className="welcomeMessage gx-text-center">
                <h2 className="gx-font-weight-light gx-mb-0 gx-font-sans-regular gx-blue-font gx-font-35 gx-mt-4">Choose your subscription</h2>
                <p className="gx-mb-0 gx-gray-font gx-font-sans-regular gx-mb-4">select according to your needs</p>
                <Form
                    form={form}
                    name="subscriptionPlan"
                    layout="vertical"
                >
                    <Form.Item
                        name="memberShipPlan"
                        rules={[{ required: true, message: 'Please select at least one plan!' }]}
                        initialValue={subscriptionPlan}
                    >
                        <Radio.Group
                            buttonStyle="solid"
                            onChange={onChange}
                        >
                            <Row className="gx-d-flex gx-flex-row  sitePlan">
                                <Col xl={12} md={12} sm={24} xs={24} className="gx-m-0">
                                    <PricingTable title="Free" listImage={blueTick} list={freeList} bgcolor={"#0D7DD9"} >

                                        {currentPlan === 'free' ||  currentPlan === 'premium'? <Radio.Button disabled={true} value="free">Select</Radio.Button> :
                                        <Radio.Button value="free">Select</Radio.Button>
                                        }
                                        
                                    </PricingTable>
                                </Col>
                                <Col xl={12} md={12} sm={24} xs={24} className="gx-m-0">
                                    <PricingTable title="Premium" listImage={greenTick} list={premiumList} bgcolor={"#3FD4A2"} >
                                        <Radio.Button value="premium">Select</Radio.Button>
                                    </PricingTable>
                                </Col>
                            </Row>
                        </Radio.Group>
                    </Form.Item>
                </Form>
            </div>


            <SimpleModal 
                
                modalFor="freeMessageSuccess_modal"
                visible={freemessageModelVisible}
                width ={350}
                closable={false}
                maskClosable={false}
                className=""
                
            >
                <div className="gx-d-flex gx-flex-column gx-align-items-center gx-justify-content-center gx-py-3 gx-px-5">
                    <img src={greenTick} alt="" className="gx-mb-3"/>   
                    <p className="gx-blue-font gx-font-weight-bold gx-mb-4">You have successfully selected your plan</p>      
                    <Button type="primary" className="gx-mb-0 gx-pt-0" onClick={()=>redirectToQuestions()}>Ok</Button>      
                </div>


            </SimpleModal> 

            
        </Widget>
    )
}

export default Index
